<script>
    export default {
        name: "MiKuPreloader",
        props: {
            show: Boolean,
            lgSize: Boolean,
            smSize: Boolean,
            isCatalog: Boolean,
            isColor: Boolean,
        },
    };
</script>

<template>
    <div
        class="global-preloader"
        :class="{
            'global-preloader--lg': lgSize,
            'global-preloader--sm': smSize,
            'global-preloader--catalog': isCatalog,
            'global-preloader--color': isColor,
        }"
        v-show="show"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
        >
            <circle
                cx="50"
                cy="50"
                r="32"
                stroke-width="6"
                stroke="#fa0f0c"
                stroke-dasharray="50 50"
                fill="none"
                stroke-linecap="round"
            ></circle>
            <circle
                cx="50"
                cy="50"
                r="24"
                stroke-width="6"
                stroke="#fa0f0c"
                stroke-dasharray="36 36"
                stroke-dashoffset="24"
                fill="none"
                stroke-linecap="round"
            ></circle>
            <circle
                cx="50"
                cy="50"
                r="16"
                stroke-width="6"
                stroke="#fa0f0c"
                stroke-dasharray="24 24"
                stroke-dashoffset="24"
                fill="none"
                stroke-linecap="round"
            ></circle>
            <circle
                cx="50"
                cy="50"
                r="8"
                stroke-width="6"
                stroke="#fa0f0c"
                stroke-dasharray="20 20"
                stroke-dashoffset="6"
                fill="none"
                stroke-linecap="round"
            ></circle>
        </svg>
    </div>
</template>

<style lang="scss">
    .global-preloader {
        @include center-absolute(0);
        margin: auto;
        @include box(100%);
        z-index: 5;
        svg {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 30%;
            height: 30%;
            transform: translate(-50%, -50%);
        }
    }

    .global-preloader svg circle {
        transform-origin: center;
        &:nth-child(1) {
            animation: rotateCircle 2s infinite linear;
        }
        &:nth-child(2) {
            animation: rotateCircle 2s infinite linear 0.2s reverse;
        }
        &:nth-child(3) {
            animation: rotateCircle 2s infinite linear 0.4s;
        }
        &:nth-child(4) {
            animation: rotateCircle 2s infinite linear 0.6s reverse;
        }
    }

    .global-preloader--sm {
        svg {
            @include box(40px);
        }
    }

    @keyframes rotateCircle {
        from {
            transform: rotate(0);
        }
        to {
            transform: rotate(360deg);
        }
    }
</style>
